import request from '@/utils/request'

// 获取对练机器人列表
export const getExerciseList = (params) => {
  return request.post('/prompt/list', params)
}
// 获取角色列表
export const roleOptions = () => {
  return request.post('/prompt/role/options')
}
// 获取故事列表
export const storyOptions = () => {
  return request.post('/prompt/story/options')
}
// 获取详情
export const getExerciseDetail = (params) => {
  return request.get(`/prompt/get/${params.id}`)
}
// 更新详情
export const updateExerciseDetail = (params) => {
  return request.post(`/prompt/upsert`, params)
}

// 故事列表查询
export const storyList = (params) => {
  return request.post(`/story/list`, params)
}
// 文件转换
export const fileText = (formData) => {
  return request.post(`/story/file/text`, formData)
}
// 保存故事
export const saveStory = (params) => {
  return request.post(`/story/identify`, params)
}
// 故事详情
export const storyDetail = (params) => {
  return request.post(`/story/get/${params.id}`)
}
// 更新故事
export const updateStory = (params) => {
  return request.post(`/story/update`, params)
}
// 删除故事
export const delStory = (params) => {
  return request.post(`/story/delete/${params.id}`)
}
// 查询任务列表
export const getTaskList = (params) => {
  return request.post(`/task_base/list`, params)
}
// 查询任务详情
export const getTaskDetail = (id) => {
  return request.post(`/task_base/get/${id}`)
}
// 故事保存
export const storySave = (params) => {
  return request.post(`/story/save`, params)
}
// 查询故事分类
export const getStoryType = () => {
  return request.post(`/story/story-type/options`)
}
